import React from 'react';
import styled from 'styled-components';
import { useStoreState } from '../store';
import { useLocale } from '../hooks/useLocale';
import { VideoType } from '../typings';
import { theme } from '../utils/theme';

export const ModifierIndicator = () => {
  const locale = useLocale();
  const videoItem = useStoreState(state => state.player.videoItem);

  const modifierEnabled = videoItem?.type === VideoType.MODIFIER;

  return modifierEnabled ? <Container>{locale.translations.ModifierIndicator.Modifier}</Container> : null;
};

const Container = styled.div`
  font-family: Lato-Bold, sans-serif;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: 0.2px;
  text-align: right;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primaryBlue};
  z-index: 900;

  @media ${theme.mobileMediaQuery} {
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 1px;
  }
`;
